
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[paramName]",
      function () {
        return require("private-next-pages/product/[paramName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[paramName]"])
      });
    }
  